import type { StreamEvent } from '@langchain/core/tracers/log_stream'
import { ChatBox, ChatMessage } from '@/components/Chat'
import Animate from './Animate'

const StreamBox: React.FC<{ streamEvents: StreamEvent[] }> = ({
  streamEvents
}) => (
  <ChatBox
    showScrollButton={
      false
      //   messages.find(
      //     m =>
      //       m.type === 'ai' &&
      //       (streamEvents[thread.id].length > 0 || m.content != null)
      //   ) != null
    }
  >
    <Animate visible>
      <div className='flex flex-col gap-4 max-w-[768px] mx-auto mb-16'>
        <ChatMessage
          streamEvents={streamEvents ?? []}
          //   message={messages.filter(m => m.type === 'ai').slice(-1)[0]}
          onEdit={
            () => {}
            // message =>  thread.submit({ messages: [message] }, { checkpoint })
          }
          //   onRegenerate={() => thread.submit(undefined, { checkpoint })}
          onRegenerate={() => {}}
          actions={
            <></>
            // meta?.branch != null &&
            // meta?.branchOptions != null && (
            //   <BranchPicker
            //     current={meta.branch}
            //     branches={meta.branchOptions}
            //     onSelect={thread.setBranch}
            //   />
            // )
          }
        />
      </div>
    </Animate>
  </ChatBox>
)

export default StreamBox
